(function ($) {
  'use strict';
  if (!$) return;

  function BloomfoldQuiz($root) {
    this.$root = $root;
    this.$form = $root.closest('form.bf-quiz-form');
    this.$slides = $root.find('.bf-quiz-slide');
    this.$progressSlides = this.$slides.filter(
      '[data-slide-type="step"], [data-slide-type="image_step"], [data-slide-type="social"], [data-slide-type="result"]'
    );
    this.currentIndex = 0;
    this.doneIcon = $root.data('done-icon') || '';
    this.requiredError = $root.data('required-error') || 'Please answer all required questions.';
    this.init();
  }

  BloomfoldQuiz.prototype.init = function () {
    var self = this;

    if ($rootHasSuccess(this.$root)) {
      var redirectUrl = this.$root.data('redirect-url');
      if (redirectUrl) {
        window.location.replace(redirectUrl);
        return;
      }
      this.$slides.not('[data-slide-type="intro"]').removeClass('is-active').attr('hidden', true);
      return;
    }

    this.buildStepNav();
    this.syncGoalCardActiveState();
    this.showSlide(0);
    this.syncAllCheckboxFields();

    this.$root.on('click', '[data-quiz-start]', function (e) {
      e.preventDefault();
      self.goNext();
    });

    this.$root.on('click', '[data-quiz-continue]', function (e) {
      e.preventDefault();
      if (self.validateCurrentSlide()) {
        self.goNext();
      }
    });

    this.$root.on('click', '[data-quiz-back]', function (e) {
      e.preventDefault();
      self.goBack();
    });

    this.$root.on('change', '[data-quiz-checkbox]', function () {
      self.syncCheckboxField($(this).data('block-id'));
    });

    this.$root.on('click', '.goal-card', function (e) {
      var $slide = $(this).closest('.bf-quiz-slide');
      var mode = $slide.data('selection') || 'single';
      var $card = $(this);
      var $input = $card.find('input');

      if (!$input.length) return;

      if (mode === 'multiple') {
        e.preventDefault();
        $card.toggleClass('active');
        $input.prop('checked', $card.hasClass('active'));
        self.syncCheckboxField($input.data('block-id'));
        $slide.find('[data-quiz-error]').hide();
        return;
      }

      e.preventDefault();
      $slide.find('.goal-card').removeClass('active');
      $slide.find('input[type="radio"]').prop('checked', false);
      $card.addClass('active');
      $input.prop('checked', true);
      $slide.find('[data-quiz-error]').hide();

      var autoAdvance = $slide.data('auto-advance');
      if (autoAdvance === true || autoAdvance === 'true') {
        setTimeout(function () {
          self.goNext();
        }, 300);
      }
    });

    if (this.$form.length) {
      this.$form.on('submit', function (e) {
        self.syncAllCheckboxFields();
        self.buildContactBody();

        var invalidSlideIndex = self.findFirstInvalidQuestionSlide();
        if (invalidSlideIndex >= 0) {
          e.preventDefault();
          self.showSlide(invalidSlideIndex);
          var $slide = self.$slides.eq(invalidSlideIndex);
          $slide
            .find('[data-quiz-error]')
            .text($slide.data('error-msg') || self.requiredError)
            .show();
        }
      });
    }
  };

  function $rootHasSuccess($root) {
    return $root.hasClass('bf-quiz-wrapper--success');
  }

  BloomfoldQuiz.prototype.syncGoalCardActiveState = function () {
    this.$root.find('.goal-card input:checked').each(function () {
      $(this).closest('.goal-card').addClass('active');
    });
  };

  BloomfoldQuiz.prototype.syncCheckboxField = function (blockId) {
    var values = [];
    this.$root
      .find('[data-quiz-checkbox][data-block-id="' + blockId + '"]:checked')
      .each(function () {
        values.push($(this).val());
      });

    this.$root
      .find('[data-quiz-checkbox-value][data-block-id="' + blockId + '"]')
      .val(values.join(', '));
  };

  BloomfoldQuiz.prototype.syncAllCheckboxFields = function () {
    var self = this;
    var blockIds = {};

    this.$root.find('[data-quiz-checkbox-value]').each(function () {
      blockIds[$(this).data('block-id')] = true;
    });

    Object.keys(blockIds).forEach(function (id) {
      self.syncCheckboxField(id);
    });
  };

  BloomfoldQuiz.prototype.buildContactBody = function () {
    var lines = ['Quiz responses:', ''];
    var self = this;

    this.$root.find('[data-quiz-question]').each(function () {
      var $question = $(this);
      var label = $question.data('question-label');
      var type = $question.data('question-type');
      var answer = '';

      if (type === 'checkbox') {
        answer = $question.find('[data-quiz-checkbox-value]').val() || '';
      } else {
        answer = $question.find('[data-quiz-radio]:checked').val() || '';
      }

      lines.push(label);
      lines.push('Answer: ' + (answer || '(none)'));
      lines.push('');
    });

    var $body = this.$root.find('[data-quiz-body]');
    if ($body.length) {
      var bodyText = lines.join('\n').trim();
      $body.val(bodyText !== '' ? bodyText : 'Quiz submission');
    }
  };

  BloomfoldQuiz.prototype.isQuestionSlideValid = function ($slide) {
    if ($slide.data('has-question') !== true && $slide.data('has-question') !== 'true') {
      return true;
    }
    if ($slide.data('required') === false || $slide.data('required') === 'false') {
      return true;
    }

    var selection = $slide.data('selection');
    if (selection === 'multiple') {
      return $slide.find('[data-quiz-checkbox]:checked').length > 0;
    }
    return $slide.find('[data-quiz-radio]:checked').length > 0;
  };

  BloomfoldQuiz.prototype.findFirstInvalidQuestionSlide = function () {
    var self = this;
    var invalidIndex = -1;

    this.$slides.each(function (index) {
      var $slide = $(this);
      if ($slide.data('slide-type') !== 'step') return;
      if ($slide.data('has-question') !== true && $slide.data('has-question') !== 'true') return;
      if ($slide.data('required') === false || $slide.data('required') === 'false') return;

      if (!self.isQuestionSlideValid($slide)) {
        invalidIndex = index;
        return false;
      }
    });

    return invalidIndex;
  };

  BloomfoldQuiz.prototype.buildStepNav = function () {
    var html = '';

    this.$progressSlides.each(function (i) {
      var isResult = $(this).data('slide-type') === 'result';
      html += '<div class="step-box" data-step-index="' + i + '">';
      html += '<span class="step" data-step-marker>';
      html += isResult ? '🎉' : String(i + 1);
      html += '</span></div>';
    });

    this.$root.find('[data-quiz-steps]').html(html);
  };

  BloomfoldQuiz.prototype.getProgressIndex = function () {
    var $current = this.$slides.eq(this.currentIndex);
    return this.$progressSlides.index($current);
  };

  BloomfoldQuiz.prototype.updateStepNav = function () {
    var self = this;
    var progressIndex = this.getProgressIndex();
    var onIntro = this.$slides.eq(this.currentIndex).data('slide-type') === 'intro';

    this.$root.find('[data-quiz-steps]').each(function () {
      var $nav = $(this);
      $nav.toggle(!onIntro);

      $nav.find('.step-box').each(function (i) {
        var $box = $(this);
        var $marker = $box.find('[data-step-marker]');
        var $targetSlide = self.$progressSlides.eq(i);
        var isResult = $targetSlide.data('slide-type') === 'result';

        $box.removeClass('active');
        $marker.removeClass('active done').empty();

        if (onIntro || progressIndex < 0) {
          $marker.text(isResult ? '🎉' : i + 1);
          return;
        }

        if (i < progressIndex) {
          $box.addClass('active');
          if (self.doneIcon) {
            $marker.addClass('done').html('<img src="' + self.doneIcon + '" alt="">');
          } else {
            $marker.addClass('done').text('✓');
          }
        } else if (i === progressIndex) {
          $box.addClass('active');
          $marker.addClass('active').text(isResult ? '🎉' : i + 1);
        } else {
          $marker.text(isResult ? '🎉' : i + 1);
        }
      });
    });
  };

  BloomfoldQuiz.prototype.showSlide = function (index) {
    if (index < 0 || index >= this.$slides.length) return;
    this.currentIndex = index;
    this.$slides.removeClass('is-active').attr('hidden', true);
    var $active = this.$slides.eq(index);
    $active.addClass('is-active').removeAttr('hidden');
    this.updateStepNav();
    this.toggleNavButtons($active);
    var top = this.$root.offset().top;
    if (top) {
      window.scrollTo({ top: top, behavior: 'smooth' });
    }
  };

  BloomfoldQuiz.prototype.toggleNavButtons = function ($slide) {
    var type = $slide.data('slide-type');
    var selection = $slide.data('selection');
    var $actions = $slide.find('[data-quiz-actions]');
    var showBack = this.currentIndex > 0;
    var showContinue =
      type === 'social' ||
      type === 'image_step' ||
      selection === 'multiple' ||
      $slide.data('show-continue') === true ||
      $slide.data('show-continue') === 'true';

    if ($actions.length) {
      $actions.find('[data-quiz-back]').toggle(showBack);
      $actions.find('[data-quiz-continue]').toggle(!!showContinue);
    }
  };

  BloomfoldQuiz.prototype.validateCurrentSlide = function () {
    var $slide = this.$slides.eq(this.currentIndex);
    var type = $slide.data('slide-type');
    if (type !== 'step') return true;

    if (!$slide.data('has-question')) return true;
    if (!$slide.data('required')) return true;

    if (!this.isQuestionSlideValid($slide)) {
      $slide
        .find('[data-quiz-error]')
        .text($slide.data('error-msg') || this.requiredError)
        .show();
      return false;
    }
    $slide.find('[data-quiz-error]').hide();
    return true;
  };

  BloomfoldQuiz.prototype.goNext = function () {
    if (!this.validateCurrentSlide()) return;
    if (this.currentIndex < this.$slides.length - 1) {
      this.showSlide(this.currentIndex + 1);
    }
  };

  BloomfoldQuiz.prototype.goBack = function () {
    if (this.currentIndex > 0) {
      this.showSlide(this.currentIndex - 1);
    }
  };

  function boot() {
    $('[data-bloomfold-quiz]').each(function () {
      new BloomfoldQuiz($(this));
    });
  }

  $(boot);
})(window.jQuery);
